import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { InvestmentPathType } from '@common-fe/common-fe';

import { api } from '@/api';
import { ERRORS_CODE } from '@/common/constants';
import { IInvestorDto } from '@/dtos';
export const QUERY_KEY = 'GET_INVESTORS';

export interface InvestorsDto {
  id: string;
  investor_id: string;
  account_id: string;
  type: string;
  automatic_investment_enabled: boolean;
  pending_sell_trades_amount?: number;
  investor_profile: {
    tolerance_model: string;
  };
  status: string;
}

export interface Investors {
  investorId: string;
  accountId: string;
  type: InvestmentPathType;
  automaticInvestmentEnabled: boolean;
  pendingTradesAmount?: number;
  toleranceModel: string;
  status: string;
}

const formatData = (data?: IInvestorDto): Investors => ({
  // @ts-ignore
  investorId: `${data?.investor_id || data?.id || ''}`,
  accountId: `${data?.account_id || ''}`,
  type: data?.type as unknown as InvestmentPathType,
  automaticInvestmentEnabled: data?.automatic_investment_enabled || false,
  // @ts-ignore
  pendingTradesAmount: data?.pending_sell_trades_amount || 0,
  toleranceModel: data?.investor_profile?.tolerance_model || '',
  status: data?.status || '',
});
const useGetInvestorsQuery = (employeeId: string) => {
  const { isLoading, isSuccess, isError, data, error } = useQuery(
    [QUERY_KEY, employeeId],
    () => api.get<IInvestorDto>(`/investors?employee_id=${employeeId}`),
    {
      enabled: !!employeeId,
      retry: 0,
    }
  );

  const formattedData = useMemo(() => formatData(data?.data), [data]);
  const isNotFound = useMemo(() => {
    // @ts-ignore
    return error?.status === ERRORS_CODE.NOT_FOUND;
  }, [error]);
  return {
    isNotFound,
    formattedData,
    isError,
    isLoading,
    isSuccess,
  };
};

export default useGetInvestorsQuery;
